/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class ProcessModel {
        private logType: string = "ProcessModel";

        public process: models.ProcessDto;
        public processConfiguration: Wars.Domain.Model.ProcessConfiguration;
        public containerVisibleForms: Wars.Domain.Model.Form[];
        public visibleContainers:Wars.Domain.Model.FormContainer[];
        public visibleForms:any={};
        //public currentForm: Wars.Domain.Model.Form;
        public currentContainer: Wars.Domain.Model.FormContainer;
        //public formData: any;
        //public currentFormDataId: string;
        public formDataDict:any = {};
        public parentForm: Wars.Domain.Model.Form;
        public processErrors: any;
        public showUserActionConfirmation: boolean;
        public userActionDto: Wars.Domain.Model.Dtos.Workflow.UserActionDto;

        constructor(
            private $location: angular.ILocationService,
            public processTypeId: string,
            public processId: string,
            private processTypeService: services.ProcessTypeService,
            private processService: services.ProcessService,
            private cacheConfigurationService: services.ConfigurationCacheService,
            private modalService: any,
            private formDataService: services.FormDataService,
            private signalRService: services.SignalrService,
            private growl: angular.growl.IGrowlService,
            private conditionService: services.ConditionService,
            private userService: services.UserService,
            private scope: angular.IScope,
            private apiActionService: services.ApiActionService,
            private processValidationService: services.ProcessValidationService,
            private $window: angular.IWindowService,
            private formContainerUniqueId?: string,
            private formDataId?: string,
            public parentFormId?: string,
            public parentFormDataId?: string,
            public parentFormName?: string) {

            
            var cb = scope.$on('userActionInitated',
                (e, args) => {
                    //console.log(args);
                    this.userActionInitiated(args);
                });
            //destroy the listener on scope destroy to avoid memory leak
            scope.$on("$destroy",
                () => {
                    cb();
                });

            cb = scope.$on('ProcessChanged',
                (e, args) => {
                    this.process = args;
                    this.processService.displayDocumentsAndDownloads(this.process);
                    this.setVisibleForms();
                });
            //destroy the listener on scope destroy to avoid memory leak
            scope.$on("$destroy",
                () => {
                    cb();
                });

            if (this.processId) {
                var self = this;

                this.processService.getProcessDto(this.processId)
                    .then(process => {
                        this.process = process;

                        this.cacheConfigurationService
                            .getVersionedProcessConfiguration(this.process.processConfigurationId)
                            .then(config => {
                                self.processConfiguration = config;
                                this.setVisibleForms();
                            });
                    });

                this.signalRService.broadcast(scope)
                    .then((broadcaster) => {
                        //console.log("broadcast");
                        broadcaster.enterProcess(self.processId, true);
                    })
                    .catch(r => {
                        services.WarsLogger.logError(r, "ProcessModel");
                    });

                let currentUser = this.userService.getCurrentUser();
                this.signalRService.listen(scope)
                    .then((listener) => {
                        let config: angular.growl.IGrowlMessageConfig = {
                            ttl: 5000
                        };

                        listener.onSignalGroupOfProcessDataUpdate((user, result) => {
                            //console.log(result);
                            if (result.type === "FieldUpdate") {
                                if (currentUser.userName !== user) {
                                    this.processService.processFormUpdateResults(this.process, result.updatedFields, this.conditionService);
                                }
                                

                                //if (this.formDataDict[form.id] === result.formDataId && currentUser.userName !== user) {
                                //    growl.info('Form has been updated by ' + user, config);
                                //}
                            } else if (result.type === "UserActionExecuted") {
                                if (currentUser.userName !== user) {
                                    this.processService.getProcessDto(this.processId)
                                        .then(process => {
                                            this.process = process;
                                            this.setVisibleForms();
                                            growl.info('An update has been made by another user: ' +
                                                user +
                                                ' and the page has been refreshed.',
                                                config);
                                        });
                                }
                            }
                        });
                    });
            }
            else {
                this.processTypeService.getExecutionProcessType(processTypeId).then(processType => {
                    if (processType.isTransient) {
                        this.cacheConfigurationService
                            .getVersionedProcessConfiguration(processType.processConfigurationId)
                            .then(config => {
                                this.process = <any>{
                                    formsVisibilities: { },
                                    containersVisibilities:{}
                                };
                                this.processConfiguration = config;

                                this.processConfiguration.myForms.forEach(f => {
                                    this.process.formsVisibilities[f.uniqueIdentifier] = { formVisiblility: 2 };
                                });
                                this.processConfiguration.myFormContainers.forEach(f => {
                                    this.process.containersVisibilities[f.uniqueIdentifier] =  true;
                                });

                                this.setVisibleForms();
                            });
                        return;
                    }


                    this.processService.createNewProcess(processTypeId).then(
                        (createProcessDto: Wars.Domain.Model.Dtos.CreateProcessDto) =>
                        {
                            if (createProcessDto.processCreated)
                            {
                                this.redirectAfterProcessCreation(processTypeId, createProcessDto.processId);
                            }
                            else if (createProcessDto.redirectRequired)
                            {
                                this.redirectInsteadOfCreateNewProcess(createProcessDto.redirectProcessTypeId, createProcessDto.redirectMessage);
                            }
                            else
                            {
                                this.processService.showProcessSubTypeModal(createProcessDto,
                                    (subTypeSystemCodeUniqueId: string) =>
                                    {
                                        this.processSubTypeSuccessCallback(processTypeId, subTypeSystemCodeUniqueId);
                                    },
                                    () => this.processSubTypeFailureCallback());
                            }
                            
                        });
                });

            }
        }

        private processSubTypeFailureCallback(): void {
            this.growl.error("Sub Type not selected");
        }

        private processSubTypeSuccessCallback(processTypeId: string, subTypeSystemCodeUniqueId: string): void {
            this.processService.createNewProcessWithSubType(processTypeId, subTypeSystemCodeUniqueId).then(
                (result: Wars.Domain.Model.Dtos.CreateProcessDto) => {
                    if (result.redirectRequired) {
                        this.redirectInsteadOfCreateNewProcess(result.redirectProcessTypeId, result.redirectMessage);
                    } else {
                        this.redirectAfterProcessCreation(processTypeId, result.processId);
                    }
                });
        }

        public goto(errorObj: any) {
            var container = Enumerable.from(this.visibleContainers).first(c => Enumerable.from(c.containerItems).any(ci => ci.form.uniqueIdentifier === errorObj.formId));

            this.currentContainer = container;
            //this.currentForm = form;
            setTimeout(() =>
                {
                    this.scope.$broadcast('stepChanged', errorObj.stepId);
                    if (errorObj.rowId) {
                        setTimeout(() => {
                            $('#' + errorObj.rowId).click();
                            setTimeout(() => { $('#' + errorObj.fieldId).focus(); }, 100);
                        }, 100);
                        
                    } else {
                        setTimeout(() => { $('#' + errorObj.fieldId).focus(); }, 100);
                    }
                }, 200);
        }

        private redirectAfterProcessCreation(processTypeId: string, processId: string): void {
            this.processId = processId;
            var path = '/ProcessType/' + processTypeId + '/Process/' + this.processId;
            services.WarsLogger.logDebug("Create new process path: " + path, this.logType);
            this.$location.path(path);
        }

        private redirectInsteadOfCreateNewProcess(processTypeId: string, message: string): void {
            if (message) {
                this.growl.error(message);
            }
            var path = '/ProcessType/' + processTypeId + "/Process";
            this.$location.path(path);
        }

        private setCurrentFormDataId(formContainer: Wars.Domain.Model.FormContainer) {

            if (!this.process.formJson) {
                this.process.formJson = <any>{};
            }

            formContainer.containerItems.forEach(item => {
                let form = item.form;
                // added undefined check becuase form was deleted but not removed from the container (This will be added as a validation eventually)
                if (form === undefined || form.formType === Wars.Domain.Model.Codes.Enums.FormType.Manage) {
                    return;
                }

                if (!this.process.formsVisibilities[form.uniqueIdentifier]) {
                    return;
                }

                //TODO: make this work with multi-instance forms
                if (this.process.formJson[form.uniqueIdentifier] &&
                    Enumerable.from(this.processConfiguration.myForms).any(f => f.maxInstances === 1 &&
                        f.uniqueIdentifier === form.uniqueIdentifier)) {
                    this.formDataDict[form.id] = Object.keys(this.process.formJson[form.uniqueIdentifier])[0];
                } else if (this.process.formJson[form.uniqueIdentifier]) {
                    this.formDataDict[form.id] = Object.keys(this.process.formJson[form.uniqueIdentifier])[0];
                } else if (this.process.id) {
                    services.WarsLogger.logError("Creating new form", "ProcessModel");
                    this.formDataDict[form.id] = null;
                    this.formDataService.createFormData(this.process.id, form.uniqueIdentifier)
                        .then(formDataId => {

                            this.processService.getProcessDto(this.processId).then((process) => {
                                this.process = process;
                                this.setCurrentFormDataId(formContainer);
                            });

                            this.formDataDict[form.id] = formDataId;
                            if (form.apiActionProcessType_id) {
                                this.apiActionService.runApiAction(form.apiActionProcessType_id, form.defaultFormValueApiActionUniqueId)
                                    .then(defaults => {
                                        if (defaults.length > 0) {
                                            form.mySteps.forEach(s => {
                                                s.formSections.forEach(fs => {
                                                    fs.fields.forEach(field => {
                                                        if (field.defaultSchemaPropertyUniqueId) {
                                                            this.process.formJson[form.uniqueIdentifier][this
                                                                .formDataDict[form.id]][field.schemaProperty
                                                                .uniqueIdentifier] = defaults[0][field
                                                                .defaultSchemaPropertyUniqueId];
                                                            this.formDataService.setFormField(
                                                                this.process.id,
                                                                form.uniqueIdentifier,
                                                                this.formDataDict[form.id],
                                                                field.schemaProperty.uniqueIdentifier,
                                                                defaults[0][field.defaultSchemaPropertyUniqueId]);
                                                        }
                                                    });
                                                });
                                            });
                                        }
                                    });
                            }
                        });
                }
            });
        }

        public changeContainer(container: Wars.Domain.Model.FormContainer) {
            this.currentContainer = container;
            this.setCurrentFormDataId(container);
        }

        private setVisibleForms() {
            //console.log('Test');
            let visibleForms = Enumerable.from(this.processConfiguration.myForms)
                .where(form => this.process.formsVisibilities[form.uniqueIdentifier] &&
                    !this.process.formsVisibilities[form.uniqueIdentifier].onlyVisibleAsChild)
                .toArray();

            var containersVisible = Enumerable.from(this.processConfiguration.myFormContainers)
                .where(i => this.process.containersVisibilities[i.uniqueIdentifier]).toArray();

            var containersWithFormsVisible = Enumerable.from(this.processConfiguration.myFormContainers)
                .where(c => Enumerable.from(c.containerItems).any(item => Enumerable.from(visibleForms).any(f => f.id == item.form_id)))
                .toArray();

            this.visibleContainers = Enumerable.from(containersVisible)
                .where(visibleContainers => Enumerable.from(containersWithFormsVisible)
                    .any(containerWithFormVisible => containerWithFormVisible.uniqueIdentifier == visibleContainers.uniqueIdentifier))
                .toArray();

            this.visibleForms = [];

            visibleForms.forEach(f => {
                this.visibleForms[f.id] = true;
            });

            if (this.visibleContainers.length > 0) {
                if (this.formContainerUniqueId) {
                    this.currentContainer = Enumerable.from(this.visibleContainers)
                        .singleOrDefault(visibleContainers => visibleContainers.uniqueIdentifier === this.formContainerUniqueId);
                }

                var currentContainerVisible = this.currentContainer !== undefined &&
                    Enumerable.from(this.visibleContainers).any(i => i.uniqueIdentifier === this.currentContainer.uniqueIdentifier);

                if (!currentContainerVisible) {
                    this.currentContainer = Enumerable.from(this.visibleContainers).orderBy(i => i.displayOrder).toArray()[0];
                }
                this.setCurrentFormDataId(this.currentContainer);
            }
        }

        public userActionInitiated(userActionDto: Wars.Domain.Model.Dtos.Workflow.UserActionDto) {
            if (userActionDto.myFormValidations) {
                let forms = Enumerable.from(this.processConfiguration.myForms)
                    .where(f => Enumerable.from(userActionDto.myFormValidations).any(fv => fv.formId == f.id))
                    .toArray();

                this.processErrors = this.processValidationService.validate(this.process, forms, this.processConfiguration);
            }

            if (!this.processErrors || this.processErrors.length == 0) {
                if (userActionDto.showConfirmation) {
                    this.showUserActionConfirmation = true;
                    this.userActionDto = userActionDto;
                } else {
                    this.executeUserAction(userActionDto);
                }
            } else {
                this.$window.scrollTo(0,0);
            }
        }

        public executeUserAction(userActionDto: Wars.Domain.Model.Dtos.Workflow.UserActionDto) {
            if (userActionDto.attachmentAllowed ||
                userActionDto.commentAllowed ||
                userActionDto.authorizedToEnterPastEffectiveDate ||
                userActionDto.authorizedToEnterFutureEffectiveDate) {
                this.showUserActionModal(userActionDto);
            } else {
                this.processService.executeUserAction(this.processId, userActionDto.id, userActionDto.processActionWorkflowBlockId)
                    .then((processDto) => {
                        this.process = processDto;
                        this.setVisibleForms();
                    });
            }
        }

        private showUserActionModal(pendingUserAction: Wars.Domain.Model.Dtos.Workflow.UserActionDto): void {
            var self = this;
            var model = new models.UserActionModalModel();
            model.processActionWorkflowBlockId = pendingUserAction.processActionWorkflowBlockId;

            var userAction = <Wars.Domain.Model.Workflow.Blocks.UserActionWorkflowBlock>Enumerable
                .from(this.processConfiguration.myStatusCodeGroup.myStatuses)
                .selectMany(i => i.myWorkflowBlocks)
                .singleOrDefault(i => i.id === pendingUserAction.id);

            if (userAction == null) {
                userAction = <Wars.Domain.Model.Workflow.Blocks.UserActionWorkflowBlock>Enumerable
                    .from(this.processConfiguration.myProcessActions)
                    .selectMany(i => i.myWorkflowBlocks)
                    .single(i => i.id === pendingUserAction.id);
            }

            this.modalService.showModal({
                    templateUrl: "./app/views/modals/_userActionModal.html",
                    controller: "userActionModalController",
                    inputs: {
                        userActionDto: pendingUserAction,
                        model: model,
                        process: this.process,
                        userActionInfoUniqueId: userAction.myUserActionInfo.uniqueIdentifier,
                        documentConfiguration: userAction.myUserActionInfo.documentConfiguration,
                        systemDocumentConfiguration: this.processConfiguration.mySystemDocumentConfiguration
                    }
                })
                .then(modal => {
                    // The modal object has the element built, if this is a bootstrap modal
                    // you can call 'modal' to show it, if it's a custom modal just show or hide
                    // it as you need to.
                    modal.element.modal();
                    modal.close.then(result => {
                        if (result) {
                            self.processService.executeUserActionWithModel(self.processId, pendingUserAction.id, model)
                                .then((processDto) => {
                                    this.process = processDto;
                                    this.setVisibleForms();
                                });
                        } else {
                            //Randy - transient user action data preservation for validation error
                            this.processService.userActionService.clearTransientUserActionData();
                            //Randy - end transient user action data preservation for validation error
                        }
                    });
                });
        }
    }
}